"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var index_1 = require("./index");
var wrapPageElement = function (_a) {
    var element = _a.element, props = _a.props;
    var pageContext = props.pageContext;
    var locale = pageContext.locale, translations = pageContext.translations;
    return locale && translations ? (react_1.default.createElement(index_1.i18nContext.Provider, { value: { locale: locale, translations: translations } }, element)) : element;
};
exports.default = wrapPageElement;
